import { classFactory } from './add-body-classes';

export default classFactory(() => document.documentElement);
